<div>
    <iframe 
    #pdfViewer
    frameBorder="0" scrolling="auto" 
    hspace="0" vspace="0" 
    style="border: none">
    </iframe>
    <div class="close-button">
        <button
        mat-icon-button
        aria-label="Close dialog">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
</div>